import React from 'react';

import {AutosuggestItem} from '@pb/kit-component-autosuggest-v2';
import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';
import {Group} from '@pb/kit-component-group';
import Loading from '@pb/kit-component-loading';

import type {ResourceSearchItem} from 'src/openapi/admin/models/ResourceSearchItem';
import type {ServerResponse} from 'src/typedef';

type Props = {
    id: string,
    busy: boolean,
    response: ServerResponse<ResourceSearchItem[]> | null,
};

export const ResourceSuggestResult = ({busy, response, id}: Props) => {
    if (busy) {
        return (
            <div id={id} className="pd-s">
                <Group><Loading type="ICON"/> Loading</Group>
            </div>
        );
    }

    if (response?.data?.length) {
        return (
            <div id={id}>
                {response.data.map(resource => (
                    <AutosuggestItem
                        key={resource.id}
                        value={resource}
                        caption={(
                            <EllipsisTextHint title={resource.name}>
                                {resource.name}
                            </EllipsisTextHint>
                        )}
                    />
                ))}
            </div>
        );
    }

    if (response?.data && !response.data.length) {
        return (
            <div id={id} className="pd-s">
                No resources found
            </div>
        );
    }

    if (response?.error) {
        return (
            <div id={id} className="pd-s">
                {response.error.message}
            </div>
        );
    }

    return null;
};
